<template>
  <div :class="classes">
    <div class="question" @click="select">{{ blok.question }}</div>
    <div class="answer" v-html="blok.answer.html"></div>
  </div>
</template>
<script>
export default {
  name: "question-answer-item",
  props: {
    blok: Object,
    selectable: Boolean
  },
  data: () => {
    return {
      selected: false
    };
  },
  methods: {
    select: function() {
      this.$emit("select", this.$props.blok);
    },
    collapse: function() {
      this.selected = false;
    },
    expand: function() {
      this.selected = true;
      try {
        gtag('event', 'question_expand', {
          'event_category': 'information_interaction',
          'event_label': this.$props.blok.tracking_ref | this.$props.blok._uid
        });
      } catch(e) {
        console.warn(e);
      }
    }
  },
  computed: {
    classes: function() {
      const selected = this.selected;
      return {
        'question-answer-item': true,
        'selectable' : this.$props.selectable,
        expanded: selected && this.$props.selectable
      };
    }
  }
};
</script>
